import { gql } from '@apollo/client';
export const DEFAULT_ADDRESS= gql` 
mutation DEFAULT_ADDRESS(
    $input: getAddressUpdateInput!
  ){
    setDefaultAddressAdmin(input:$input) {
    message
  }
}
`;